import verticalSymbols from "../symbols/verticals";
import { HttpRegularPost, HttpRequestPost } from "../../service";
const verticalsSymbolsAction = () => ({
  type: verticalSymbols.GET_VERTICALS,
});
const verticalsSymbolsSuccessAction = (data: any) => ({
  type: verticalSymbols.GET_VERTICALS_SUCCESS,
  payload: data,
});
const verticalsSymbolsFailureAction = (data: any) => ({
  type: verticalSymbols.GET_VERTICALS_FAILURE,
  payload: data,
});
const clearverticalsSymbolsAction = () => ({
  type: verticalSymbols.CLEAR_GET_VERTICALS,
});

export function getVerticalsSymbols() {
  return (dispatch: any) => {
    dispatch(verticalsSymbolsAction());
    HttpRequestPost(
      "/upc/vertical/list",
      dispatch,
      verticalsSymbolsSuccessAction,
      verticalsSymbolsFailureAction,
      true,
      { Query: "", Filter: "null", OrderBy: "Asc" }
    );
  };
}

export function getVerticalsSymbolsWithParams(
  Query: string,
  OrderBy?: string | null
) {
  return (dispatch: any) => {
    dispatch(verticalsSymbolsAction());
    HttpRequestPost(
      `/upc/vertical/list`,
      dispatch,
      verticalsSymbolsSuccessAction,
      verticalsSymbolsFailureAction,
      true,
      { OrderBy, Query }
    );
  };
}

export function addNewVertical(
  body: any,
  failAction?: any,
  callback?: (resp?: any) => void
) {
  return (dispatch: any) => {
    HttpRegularPost("/upc/vertical", body, {
      dispatch: dispatch,
      actionSuccess: getVerticalsSymbols,
      actionFailure: failAction,
      callback,
    });
  };
}

export function clearVerticalsSymbols() {
  return (dispatch: any) => {
    dispatch(clearverticalsSymbolsAction());
  };
}
